import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axiosProjectKPIs from 'app/api/apiProjectKPI';

export const getProjectKPIs = createAsyncThunk('commonAPI/projectkpis/getProjectKPIs', async () => {
   const params = { ...axiosProjectKPIs.apiUnitItem.filterListDM };

   const response = await axiosProjectKPIs.apiUnitItem.list({ ...params });
   const data = await response.data;

   return data === undefined ? null : data;
});

const projectkpisCommonDataAdapter = createEntityAdapter({
   selectId: (unitItem) => unitItem.iId,
});

export const { selectAll: selectProjectKPIsCommon } = projectkpisCommonDataAdapter.getSelectors(
   (state) => state.commonAPI.projectkpis.dataProjectKPIs
);

const projectKPIsCommonSlice = createSlice({
   name: 'projectkpis ',
   initialState: {
      dataUnitItems: projectkpisCommonDataAdapter.getInitialState(),
   },
   reducers: {
      setLoading: {
         reducer: (state, action) => {
            state.loading = action.payload;
         },
      },
   },
   extraReducers: {
      [getProjectKPIs.fulfilled](state, { payload }) {
         projectkpisCommonDataAdapter.setAll(state.dataProjectKPIs, payload);
         // const newEmptyValue = { iId: 0, sCod: 'TBA' };
         // incotermsCommonDataAdapter.addOne(state.dataIncoterms, newEmptyValue);
      },
   },
});

export const { setLoading } = projectKPIsCommonSlice.actions;

export default projectKPIsCommonSlice.reducer;
